import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-request-complete-modal',
  templateUrl: './request-complete-modal.component.html',
  styleUrls: ['./request-complete-modal.component.css']
})
export class RequestCompleteModalComponent implements OnInit {
  @Input() public request: any;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

}
